/* eslint-disable */
"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentServicesWeb = void 0;
var json_proto_serializer_1 = require("@wix/json-proto-serializer");
var http_1 = require("@wix/ambassador/runtime/http");
var PaymentServicesWeb = function (baseUrl, httpClientConfig) {
    var httpClient = new http_1.AmbassadorHTTPClient(baseUrl, httpClientConfig);
    return {
        AccountService: function () {
            return function (headers) {
                var service = {
                    get: function (getAccountRequest) { return httpClient.invoke('GET', '/api/payments/v2/accounts/{accountId}', getAccountRequest, headers); },
                };
                service.get.__http_method = 'GET';
                service.get.__http_url = '/api/payments/v2/accounts/{accountId}';
                return service;
            };
        },
        ApplePayPaymentMethodService: function () {
            return function (headers) {
                var service = {
                    validateMerchant: function (validateMerchantRequest) {
                        return httpClient.invoke('POST', '/api/payments/v2/accounts/{account_id}/apple-pay-validate-merchant', validateMerchantRequest, headers);
                    },
                };
                service.validateMerchant.__http_method = 'POST';
                service.validateMerchant.__http_url = '/api/payments/v2/accounts/{account_id}/apple-pay-validate-merchant';
                return service;
            };
        },
        BackofficeTransactionService: function () {
            return function (headers) {
                var service = {
                    list: function (listBackofficeTransactionsRequest) { return __awaiter(void 0, void 0, void 0, function () {
                        var requestTransformations, serializedPayload, response, responseTransformations, deSerializedResponse;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    requestTransformations = [
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['from'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['to'] },
                                    ];
                                    serializedPayload = json_proto_serializer_1.batchToJson(listBackofficeTransactionsRequest, requestTransformations);
                                    return [4 /*yield*/, httpClient.invoke('GET', '/api/merchant/v2/backoffice/transactions', serializedPayload, headers)];
                                case 1:
                                    response = _a.sent();
                                    responseTransformations = [
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['transactions', 'createdAt'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['transactions', 'updatedAt'] },
                                    ];
                                    deSerializedResponse = json_proto_serializer_1.batchFromJson(response, responseTransformations);
                                    return [2 /*return*/, deSerializedResponse];
                            }
                        });
                    }); },
                };
                service.list.__http_method = 'GET';
                service.list.__http_url = '/api/merchant/v2/backoffice/transactions';
                return service;
            };
        },
        CreditCardService: function () {
            return function (headers) {
                var service = {
                    create: function (createCreditCardRequest) {
                        return httpClient.invoke('POST', '/api/v2/credit-cards', createCreditCardRequest, headers);
                    },
                    createFromToken: function (createFromTokenRequest) {
                        return httpClient.invoke('POST', '/api/v2/credit-cards/create-from-token', createFromTokenRequest, headers);
                    },
                    delete: function (deleteCreditCardRequest) {
                        return httpClient.invoke('DELETE', '/api/v2/credit-cards/{credit_card_id}', deleteCreditCardRequest, headers);
                    },
                    get: function (getCreditCardRequest) {
                        return httpClient.invoke('GET', '/api/v2/credit-cards/{credit_card_id}', getCreditCardRequest, headers);
                    },
                    list: function (listCreditCardRequest) { return httpClient.invoke('GET', '/api/v2/credit-cards', listCreditCardRequest, headers); },
                    markAsPrimary: function (markAsPrimaryCreditCardRequest) {
                        return httpClient.invoke('POST', '/api/v2/credit-cards/{credit_card_id}/primary', markAsPrimaryCreditCardRequest, headers);
                    },
                    update: function (updateCreditCardRequest) {
                        return httpClient.invoke('PATCH', '/api/v2/credit-cards/{credit_card_id}', updateCreditCardRequest, headers);
                    },
                };
                service.create.__http_method = 'POST';
                service.create.__http_url = '/api/v2/credit-cards';
                service.createFromToken.__http_method = 'POST';
                service.createFromToken.__http_url = '/api/v2/credit-cards/create-from-token';
                service.delete.__http_method = 'DELETE';
                service.delete.__http_url = '/api/v2/credit-cards/{credit_card_id}';
                service.get.__http_method = 'GET';
                service.get.__http_url = '/api/v2/credit-cards/{credit_card_id}';
                service.list.__http_method = 'GET';
                service.list.__http_url = '/api/v2/credit-cards';
                service.markAsPrimary.__http_method = 'POST';
                service.markAsPrimary.__http_url = '/api/v2/credit-cards/{credit_card_id}/primary';
                service.update.__http_method = 'PATCH';
                service.update.__http_url = '/api/v2/credit-cards/{credit_card_id}';
                return service;
            };
        },
        GooglePayPaymentMethodService: function () {
            return function (headers) {
                var service = {
                    googlePayStartPayment: function (googlePayStartPaymentRequest) {
                        return httpClient.invoke('POST', '/api/payments/v2/accounts/google-pay-start-payment', googlePayStartPaymentRequest, headers);
                    },
                };
                service.googlePayStartPayment.__http_method = 'POST';
                service.googlePayStartPayment.__http_url = '/api/payments/v2/accounts/google-pay-start-payment';
                return service;
            };
        },
        InternalProvidersRefundService: function () {
            return function (headers) {
                var service = {
                    markTransactionRefunded: function (markTransactionRefundedRequest) {
                        return httpClient.invoke('POST', '/api/internal/merchant/transactions/{transaction_id}/mark-refunded', markTransactionRefundedRequest, headers);
                    },
                    providerRefund: function (providerRefundRequest) {
                        return httpClient.invoke('POST', '/api/internal/merchant/transactions/{transaction_id}/refund', providerRefundRequest, headers);
                    },
                };
                service.markTransactionRefunded.__http_method = 'POST';
                service.markTransactionRefunded.__http_url = '/api/internal/merchant/transactions/{transaction_id}/mark-refunded';
                service.providerRefund.__http_method = 'POST';
                service.providerRefund.__http_url = '/api/internal/merchant/transactions/{transaction_id}/refund';
                return service;
            };
        },
        MandatoryFieldService: function () {
            return function (headers) {
                var service = {
                    list: function (listMandatoryFieldsRequest) {
                        return httpClient.invoke('GET', '/api/payments/v2/mandatory-fields', listMandatoryFieldsRequest, headers);
                    },
                };
                service.list.__http_method = 'GET';
                service.list.__http_url = '/api/payments/v2/mandatory-fields';
                return service;
            };
        },
        MetadataService: function () {
            return function (headers) {
                var service = {
                    listPaymentMethodsByCountry: function (listPaymentMethodsByCountryRequest) {
                        return httpClient.invoke('GET', '/api/metadata/v1/countries/{country}/methods', listPaymentMethodsByCountryRequest, headers);
                    },
                };
                service.listPaymentMethodsByCountry.__http_method = 'GET';
                service.listPaymentMethodsByCountry.__http_url = '/api/metadata/v1/countries/{country}/methods';
                return service;
            };
        },
        OrderService: function () {
            return function (headers) {
                var service = {
                    anonymizeOrders: function (anonymizeOrdersRequest) {
                        return httpClient.invoke('POST', '/api/payments/v2/orders/anonymize', anonymizeOrdersRequest, headers);
                    },
                    cancelSubscription: function (cancelSubscriptionRequest) {
                        return httpClient.invoke('DELETE', '/api/payments/v2/orders/{order_id}/subscription', cancelSubscriptionRequest, headers);
                    },
                    clearPaymentCredentials: function (clearPaymentCredentialsRequest) {
                        return httpClient.invoke('POST', '/api/payments/v2/orders/{order_id}/clear-payment-credentials', clearPaymentCredentialsRequest, headers);
                    },
                    create: function (createOrderRequest) { return __awaiter(void 0, void 0, void 0, function () {
                        var requestTransformations, serializedPayload, response, responseTransformations, deSerializedResponse;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    requestTransformations = [
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['description', 'subscription', 'firstCycleStartDate'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['description', 'fulfillmentDate'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['cofIntent', 'setupCofRecurring', 'mandateOptions', 'interval', 'startDate'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['cofIntent', 'setupCofRecurring', 'mandateOptions', 'interval', 'endDate'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['cofIntent', 'setupCofUnscheduled', 'mandateOptions', 'interval', 'startDate'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['cofIntent', 'setupCofUnscheduled', 'mandateOptions', 'interval', 'endDate'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['expirationDate'] },
                                    ];
                                    serializedPayload = json_proto_serializer_1.batchToJson(createOrderRequest, requestTransformations);
                                    return [4 /*yield*/, httpClient.invoke('POST', '/api/payments/v2/orders', serializedPayload, headers)];
                                case 1:
                                    response = _a.sent();
                                    responseTransformations = [
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['order', 'description', 'subscription', 'firstCycleStartDate'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['order', 'description', 'fulfillmentDate'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['order', 'statuses', 'ts'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['charge', 'state', 'transactionStatus', 'ts'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['charge', 'state', 'barcodeDisplay', 'expirationDate'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['charge', 'state', 'qrCodeDisplay', 'expirationDate'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['charge', 'state', 'webPageDisplay', 'expirationDate'] },
                                    ];
                                    deSerializedResponse = json_proto_serializer_1.batchFromJson(response, responseTransformations);
                                    return [2 /*return*/, deSerializedResponse];
                            }
                        });
                    }); },
                    disableSubscription: function (disableSubscriptionRequest) {
                        return httpClient.invoke('POST', '/api/payments/v2/orders/{order_id}/subscription/disable', disableSubscriptionRequest, headers);
                    },
                    enableSubscription: function (enableSubscriptionRequest) {
                        return httpClient.invoke('POST', '/api/payments/v2/orders/{order_id}/subscription/enable', enableSubscriptionRequest, headers);
                    },
                    expire: function (expireOrderRequest) {
                        return httpClient.invoke('POST', '/api/payments/v2/orders/{order_id}/expire', expireOrderRequest, headers);
                    },
                    findAgreementIdByOrderId: function (findAgreementIdByOrderIdRequest) {
                        return httpClient.invoke('GET', '/api/payments/v2/orders/{order_id}/agreement', findAgreementIdByOrderIdRequest, headers);
                    },
                    get: function (getOrderRequest) { return __awaiter(void 0, void 0, void 0, function () {
                        var response, responseTransformations, deSerializedResponse;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, httpClient.invoke('GET', '/api/payments/v2/orders/{order_id}', getOrderRequest, headers)];
                                case 1:
                                    response = _a.sent();
                                    responseTransformations = [
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['order', 'description', 'subscription', 'firstCycleStartDate'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['order', 'description', 'fulfillmentDate'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['order', 'statuses', 'ts'] },
                                    ];
                                    deSerializedResponse = json_proto_serializer_1.batchFromJson(response, responseTransformations);
                                    return [2 /*return*/, deSerializedResponse];
                            }
                        });
                    }); },
                    getSubscriptionInfo: function (getSubscriptionInfoRequest) { return __awaiter(void 0, void 0, void 0, function () {
                        var response, responseTransformations, deSerializedResponse;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, httpClient.invoke('GET', '/api/payments/v2/orders/{order_id}/subscription/info', getSubscriptionInfoRequest, headers)];
                                case 1:
                                    response = _a.sent();
                                    responseTransformations = [
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['lastSuccessfullyChargedDate'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['nextChargeAttemptDate'] },
                                    ];
                                    deSerializedResponse = json_proto_serializer_1.batchFromJson(response, responseTransformations);
                                    return [2 /*return*/, deSerializedResponse];
                            }
                        });
                    }); },
                    reactivateSubscription: function (reactivateSubscriptionRequest) {
                        return httpClient.invoke('POST', '/api/payments/v2/orders/{order_id}/subscription/reactivate', reactivateSubscriptionRequest, headers);
                    },
                    setup: function (setupRequest) { return __awaiter(void 0, void 0, void 0, function () {
                        var requestTransformations, serializedPayload, response, responseTransformations, deSerializedResponse;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    requestTransformations = [{ typeName: 'google.protobuf.Timestamp', pathInPayload: ['expirationDate'] }];
                                    serializedPayload = json_proto_serializer_1.batchToJson(setupRequest, requestTransformations);
                                    return [4 /*yield*/, httpClient.invoke('POST', '/api/payments/v2/orders/setup', serializedPayload, headers)];
                                case 1:
                                    response = _a.sent();
                                    responseTransformations = [
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['order', 'description', 'subscription', 'firstCycleStartDate'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['order', 'description', 'fulfillmentDate'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['order', 'statuses', 'ts'] },
                                    ];
                                    deSerializedResponse = json_proto_serializer_1.batchFromJson(response, responseTransformations);
                                    return [2 /*return*/, deSerializedResponse];
                            }
                        });
                    }); },
                    suspendSubscription: function (suspendSubscriptionRequest) {
                        return httpClient.invoke('POST', '/api/payments/v2/orders/{order_id}/subscription/suspend', suspendSubscriptionRequest, headers);
                    },
                    syncOrder: function (syncOrderRequest) { return __awaiter(void 0, void 0, void 0, function () {
                        var response, responseTransformations, deSerializedResponse;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, httpClient.invoke('POST', '/api/payments/v2/orders/{order_id}/sync', syncOrderRequest, headers)];
                                case 1:
                                    response = _a.sent();
                                    responseTransformations = [
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['order', 'description', 'subscription', 'firstCycleStartDate'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['order', 'description', 'fulfillmentDate'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['order', 'statuses', 'ts'] },
                                    ];
                                    deSerializedResponse = json_proto_serializer_1.batchFromJson(response, responseTransformations);
                                    return [2 /*return*/, deSerializedResponse];
                            }
                        });
                    }); },
                    update: function (updateOrderRequest) { return __awaiter(void 0, void 0, void 0, function () {
                        var requestTransformations, serializedPayload, response, responseTransformations, deSerializedResponse;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    requestTransformations = [
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['description', 'subscription', 'firstCycleStartDate'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['description', 'fulfillmentDate'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['expirationDate'] },
                                    ];
                                    serializedPayload = json_proto_serializer_1.batchToJson(updateOrderRequest, requestTransformations);
                                    return [4 /*yield*/, httpClient.invoke('PUT', '/api/payments/v2/orders/{order_id}', serializedPayload, headers)];
                                case 1:
                                    response = _a.sent();
                                    responseTransformations = [
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['order', 'description', 'subscription', 'firstCycleStartDate'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['order', 'description', 'fulfillmentDate'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['order', 'statuses', 'ts'] },
                                    ];
                                    deSerializedResponse = json_proto_serializer_1.batchFromJson(response, responseTransformations);
                                    return [2 /*return*/, deSerializedResponse];
                            }
                        });
                    }); },
                    updateBuyerInfo: function (updateBuyerInfoRequest) { return __awaiter(void 0, void 0, void 0, function () {
                        var response, responseTransformations, deSerializedResponse;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, httpClient.invoke('POST', '/api/payments/v2/orders/{order_id}/buyer-info', updateBuyerInfoRequest, headers)];
                                case 1:
                                    response = _a.sent();
                                    responseTransformations = [
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['description', 'subscription', 'firstCycleStartDate'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['description', 'fulfillmentDate'] },
                                    ];
                                    deSerializedResponse = json_proto_serializer_1.batchFromJson(response, responseTransformations);
                                    return [2 /*return*/, deSerializedResponse];
                            }
                        });
                    }); },
                    updateSubscription: function (updateSubscriptionRequest) { return __awaiter(void 0, void 0, void 0, function () {
                        var requestTransformations, serializedPayload, response, responseTransformations, deSerializedResponse;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    requestTransformations = [{ typeName: 'google.protobuf.Timestamp', pathInPayload: ['firstCycleStartDate'] }];
                                    serializedPayload = json_proto_serializer_1.batchToJson(updateSubscriptionRequest, requestTransformations);
                                    return [4 /*yield*/, httpClient.invoke('PATCH', '/api/payments/v2/orders/{order_id}/subscription', serializedPayload, headers)];
                                case 1:
                                    response = _a.sent();
                                    responseTransformations = [
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['description', 'subscription', 'firstCycleStartDate'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['description', 'fulfillmentDate'] },
                                    ];
                                    deSerializedResponse = json_proto_serializer_1.batchFromJson(response, responseTransformations);
                                    return [2 /*return*/, deSerializedResponse];
                            }
                        });
                    }); },
                };
                service.anonymizeOrders.__http_method = 'POST';
                service.anonymizeOrders.__http_url = '/api/payments/v2/orders/anonymize';
                service.cancelSubscription.__http_method = 'DELETE';
                service.cancelSubscription.__http_url = '/api/payments/v2/orders/{order_id}/subscription';
                service.clearPaymentCredentials.__http_method = 'POST';
                service.clearPaymentCredentials.__http_url = '/api/payments/v2/orders/{order_id}/clear-payment-credentials';
                service.create.__http_method = 'POST';
                service.create.__http_url = '/api/payments/v2/orders';
                service.disableSubscription.__http_method = 'POST';
                service.disableSubscription.__http_url = '/api/payments/v2/orders/{order_id}/subscription/disable';
                service.enableSubscription.__http_method = 'POST';
                service.enableSubscription.__http_url = '/api/payments/v2/orders/{order_id}/subscription/enable';
                service.expire.__http_method = 'POST';
                service.expire.__http_url = '/api/payments/v2/orders/{order_id}/expire';
                service.findAgreementIdByOrderId.__http_method = 'GET';
                service.findAgreementIdByOrderId.__http_url = '/api/payments/v2/orders/{order_id}/agreement';
                service.get.__http_method = 'GET';
                service.get.__http_url = '/api/payments/v2/orders/{order_id}';
                service.getSubscriptionInfo.__http_method = 'GET';
                service.getSubscriptionInfo.__http_url = '/api/payments/v2/orders/{order_id}/subscription/info';
                service.reactivateSubscription.__http_method = 'POST';
                service.reactivateSubscription.__http_url = '/api/payments/v2/orders/{order_id}/subscription/reactivate';
                service.setup.__http_method = 'POST';
                service.setup.__http_url = '/api/payments/v2/orders/setup';
                service.suspendSubscription.__http_method = 'POST';
                service.suspendSubscription.__http_url = '/api/payments/v2/orders/{order_id}/subscription/suspend';
                service.syncOrder.__http_method = 'POST';
                service.syncOrder.__http_url = '/api/payments/v2/orders/{order_id}/sync';
                service.update.__http_method = 'PUT';
                service.update.__http_url = '/api/payments/v2/orders/{order_id}';
                service.updateBuyerInfo.__http_method = 'POST';
                service.updateBuyerInfo.__http_url = '/api/payments/v2/orders/{order_id}/buyer-info';
                service.updateSubscription.__http_method = 'PATCH';
                service.updateSubscription.__http_url = '/api/payments/v2/orders/{order_id}/subscription';
                return service;
            };
        },
        PaymentDebugService: function () {
            return function (headers) {
                var service = {
                    truncatePaymentAuditPartitions: function (truncatePaymentAuditPartitionsRequest) { return __awaiter(void 0, void 0, void 0, function () {
                        var response, responseTransformations, deSerializedResponse;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, httpClient.invoke('POST', '/payment-audit-partitions/truncate', truncatePaymentAuditPartitionsRequest, headers)];
                                case 1:
                                    response = _a.sent();
                                    responseTransformations = [{ typeName: 'uint64', pathInPayload: ['truncatedPartitions', 'rowsNumber'] }];
                                    deSerializedResponse = json_proto_serializer_1.batchFromJson(response, responseTransformations);
                                    return [2 /*return*/, deSerializedResponse];
                            }
                        });
                    }); },
                };
                service.truncatePaymentAuditPartitions.__http_method = 'POST';
                service.truncatePaymentAuditPartitions.__http_url = '/payment-audit-partitions/truncate';
                return service;
            };
        },
        PaymentDetailsService: function () {
            return function (headers) {
                var service = {
                    create: function (createPaymentDetailsRequest) {
                        return httpClient.invoke('POST', '/api/payments/v2/payment-details', createPaymentDetailsRequest, headers);
                    },
                };
                service.create.__http_method = 'POST';
                service.create.__http_url = '/api/payments/v2/payment-details';
                return service;
            };
        },
        PaymentMethodService: function () {
            return function (headers) {
                var service = {
                    get: function (getPaymentMethodRequest) {
                        return httpClient.invoke('GET', '/api/payments/v2/accounts/{account_id}/payment-methods/{payment_method}', getPaymentMethodRequest, headers);
                    },
                    getBuyNowPayLaterMethod: function (getBuyNowPayLaterMethodRequest) {
                        return httpClient.invoke('GET', '/api/payments/v2/accounts/{account_id}/bnpl/payment-methods/{payment_method}', getBuyNowPayLaterMethodRequest, headers);
                    },
                    getSavedPaymentMethodDetailsByAgreementId: function (getSavedPaymentMethodDetailsByAgreementIdRequest) {
                        return httpClient.invoke('GET', '/api/payments/v2/payment-agreements/{payment_agreement_id}/payment-method', getSavedPaymentMethodDetailsByAgreementIdRequest, headers);
                    },
                    list: function (payV2ListPaymentMethodsRequest) {
                        return httpClient.invoke('GET', '/api/payments/v2/accounts/{account_id}/payment-methods', payV2ListPaymentMethodsRequest, headers);
                    },
                    listBuyNowPayLaterMethods: function (listBuyNowPayLaterMethodsRequest) {
                        return httpClient.invoke('GET', '/api/payments/v2/accounts/{account_id}/bnpl/payment-methods', listBuyNowPayLaterMethodsRequest, headers);
                    },
                    listExpressPaymentMethods: function (listExpressPaymentMethodsRequest) {
                        return httpClient.invoke('GET', '/api/payments/v2/accounts/{account_id}/express-payment-methods', listExpressPaymentMethodsRequest, headers);
                    },
                };
                service.get.__http_method = 'GET';
                service.get.__http_url = '/api/payments/v2/accounts/{account_id}/payment-methods/{payment_method}';
                service.getBuyNowPayLaterMethod.__http_method = 'GET';
                service.getBuyNowPayLaterMethod.__http_url = '/api/payments/v2/accounts/{account_id}/bnpl/payment-methods/{payment_method}';
                service.getSavedPaymentMethodDetailsByAgreementId.__http_method = 'GET';
                service.getSavedPaymentMethodDetailsByAgreementId.__http_url = '/api/payments/v2/payment-agreements/{payment_agreement_id}/payment-method';
                service.list.__http_method = 'GET';
                service.list.__http_url = '/api/payments/v2/accounts/{account_id}/payment-methods';
                service.listBuyNowPayLaterMethods.__http_method = 'GET';
                service.listBuyNowPayLaterMethods.__http_url = '/api/payments/v2/accounts/{account_id}/bnpl/payment-methods';
                service.listExpressPaymentMethods.__http_method = 'GET';
                service.listExpressPaymentMethods.__http_url = '/api/payments/v2/accounts/{account_id}/express-payment-methods';
                return service;
            };
        },
        PaymentMethodsService: function () {
            return function (headers) {
                var service = {
                    connect: function (connectPaymentMethodsRequest) {
                        return httpClient.invoke('POST', '/api/merchant/v2/payment-methods/connect', connectPaymentMethodsRequest, headers);
                    },
                    list: function (merchantV2ListPaymentMethodsRequest) {
                        return httpClient.invoke('GET', '/api/merchant/v2/payment-methods', merchantV2ListPaymentMethodsRequest, headers);
                    },
                };
                service.connect.__http_method = 'POST';
                service.connect.__http_url = '/api/merchant/v2/payment-methods/connect';
                service.list.__http_method = 'GET';
                service.list.__http_url = '/api/merchant/v2/payment-methods';
                return service;
            };
        },
        PaymentService: function () {
            return function (headers) {
                var service = {
                    capture: function (captureRequest) { return __awaiter(void 0, void 0, void 0, function () {
                        var response, responseTransformations, deSerializedResponse;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, httpClient.invoke('POST', '/api/payments/v2/charges/{charge_id}/capture', captureRequest, headers)];
                                case 1:
                                    response = _a.sent();
                                    responseTransformations = [
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['charge', 'state', 'transactionStatus', 'ts'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['charge', 'state', 'barcodeDisplay', 'expirationDate'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['charge', 'state', 'qrCodeDisplay', 'expirationDate'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['charge', 'state', 'webPageDisplay', 'expirationDate'] },
                                    ];
                                    deSerializedResponse = json_proto_serializer_1.batchFromJson(response, responseTransformations);
                                    return [2 /*return*/, deSerializedResponse];
                            }
                        });
                    }); },
                    charge: function (chargeRequest) { return __awaiter(void 0, void 0, void 0, function () {
                        var requestTransformations, serializedPayload, response, responseTransformations, deSerializedResponse;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    requestTransformations = [
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['description', 'subscription', 'firstCycleStartDate'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['description', 'fulfillmentDate'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['expirationDate'] },
                                    ];
                                    serializedPayload = json_proto_serializer_1.batchToJson(chargeRequest, requestTransformations);
                                    return [4 /*yield*/, httpClient.invoke('POST', '/api/payments/v2/accounts/{account_id}/charges', serializedPayload, headers)];
                                case 1:
                                    response = _a.sent();
                                    responseTransformations = [
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['charge', 'state', 'transactionStatus', 'ts'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['charge', 'state', 'barcodeDisplay', 'expirationDate'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['charge', 'state', 'qrCodeDisplay', 'expirationDate'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['charge', 'state', 'webPageDisplay', 'expirationDate'] },
                                    ];
                                    deSerializedResponse = json_proto_serializer_1.batchFromJson(response, responseTransformations);
                                    return [2 /*return*/, deSerializedResponse];
                            }
                        });
                    }); },
                    chargeForOrder: function (chargeForOrderRequest) { return __awaiter(void 0, void 0, void 0, function () {
                        var response, responseTransformations, deSerializedResponse;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, httpClient.invoke('POST', '/api/payments/v2/orders/{order_id}/charges', chargeForOrderRequest, headers)];
                                case 1:
                                    response = _a.sent();
                                    responseTransformations = [
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['charge', 'state', 'transactionStatus', 'ts'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['charge', 'state', 'barcodeDisplay', 'expirationDate'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['charge', 'state', 'qrCodeDisplay', 'expirationDate'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['charge', 'state', 'webPageDisplay', 'expirationDate'] },
                                    ];
                                    deSerializedResponse = json_proto_serializer_1.batchFromJson(response, responseTransformations);
                                    return [2 /*return*/, deSerializedResponse];
                            }
                        });
                    }); },
                    get: function (getChargeRequest) { return __awaiter(void 0, void 0, void 0, function () {
                        var response, responseTransformations, deSerializedResponse;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, httpClient.invoke('GET', '/api/payments/v2/charges/{charge_id}', getChargeRequest, headers)];
                                case 1:
                                    response = _a.sent();
                                    responseTransformations = [
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['charge', 'state', 'transactionStatus', 'ts'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['charge', 'state', 'barcodeDisplay', 'expirationDate'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['charge', 'state', 'qrCodeDisplay', 'expirationDate'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['charge', 'state', 'webPageDisplay', 'expirationDate'] },
                                    ];
                                    deSerializedResponse = json_proto_serializer_1.batchFromJson(response, responseTransformations);
                                    return [2 /*return*/, deSerializedResponse];
                            }
                        });
                    }); },
                    list: function (listChargesRequest) { return __awaiter(void 0, void 0, void 0, function () {
                        var response, responseTransformations, deSerializedResponse;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, httpClient.invoke('GET', '/api/payments/v2/orders/{order_id}/charges', listChargesRequest, headers)];
                                case 1:
                                    response = _a.sent();
                                    responseTransformations = [
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['charges', 'state', 'transactionStatus', 'ts'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['charges', 'state', 'barcodeDisplay', 'expirationDate'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['charges', 'state', 'qrCodeDisplay', 'expirationDate'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['charges', 'state', 'webPageDisplay', 'expirationDate'] },
                                    ];
                                    deSerializedResponse = json_proto_serializer_1.batchFromJson(response, responseTransformations);
                                    return [2 /*return*/, deSerializedResponse];
                            }
                        });
                    }); },
                    updateChargeInfo: function (updateChargeInfoRequest) { return __awaiter(void 0, void 0, void 0, function () {
                        var requestTransformations, serializedPayload, response;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    requestTransformations = [{ typeName: 'google.protobuf.Timestamp', pathInPayload: ['fulfillmentDate'] }];
                                    serializedPayload = json_proto_serializer_1.batchToJson(updateChargeInfoRequest, requestTransformations);
                                    return [4 /*yield*/, httpClient.invoke('POST', '/api/payments/v2/charges/{charge_id}', serializedPayload, headers)];
                                case 1:
                                    response = _a.sent();
                                    return [2 /*return*/, response];
                            }
                        });
                    }); },
                    void: function (voidRequest) { return __awaiter(void 0, void 0, void 0, function () {
                        var response, responseTransformations, deSerializedResponse;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, httpClient.invoke('POST', '/api/payments/v2/charges/{charge_id}/void', voidRequest, headers)];
                                case 1:
                                    response = _a.sent();
                                    responseTransformations = [
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['charge', 'state', 'transactionStatus', 'ts'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['charge', 'state', 'barcodeDisplay', 'expirationDate'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['charge', 'state', 'qrCodeDisplay', 'expirationDate'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['charge', 'state', 'webPageDisplay', 'expirationDate'] },
                                    ];
                                    deSerializedResponse = json_proto_serializer_1.batchFromJson(response, responseTransformations);
                                    return [2 /*return*/, deSerializedResponse];
                            }
                        });
                    }); },
                };
                service.capture.__http_method = 'POST';
                service.capture.__http_url = '/api/payments/v2/charges/{charge_id}/capture';
                service.charge.__http_method = 'POST';
                service.charge.__http_url = '/api/payments/v2/accounts/{account_id}/charges';
                service.chargeForOrder.__http_method = 'POST';
                service.chargeForOrder.__http_url = '/api/payments/v2/orders/{order_id}/charges';
                service.get.__http_method = 'GET';
                service.get.__http_url = '/api/payments/v2/charges/{charge_id}';
                service.list.__http_method = 'GET';
                service.list.__http_url = '/api/payments/v2/orders/{order_id}/charges';
                service.updateChargeInfo.__http_method = 'POST';
                service.updateChargeInfo.__http_url = '/api/payments/v2/charges/{charge_id}';
                service.void.__http_method = 'POST';
                service.void.__http_url = '/api/payments/v2/charges/{charge_id}/void';
                return service;
            };
        },
        PayPalPaymentMethodService: function () {
            return function (headers) {
                var service = {
                    createCheckout: function (createCheckoutRequest) {
                        return httpClient.invoke('POST', '/api/payments/v2/accounts/{account_id}/paypal-checkout', createCheckoutRequest, headers);
                    },
                    getPaymentDetails: function (getPaymentDetailsRequest) {
                        return httpClient.invoke('GET', '/api/payments/v2/accounts/{account_id}/paypal-checkout/{order_id}/payment-details', getPaymentDetailsRequest, headers);
                    },
                    updateCheckout: function (updateCheckoutRequest) {
                        return httpClient.invoke('PUT', '/api/payments/v2/accounts/{account_id}/paypal-checkout/{order_id}', updateCheckoutRequest, headers);
                    },
                };
                service.createCheckout.__http_method = 'POST';
                service.createCheckout.__http_url = '/api/payments/v2/accounts/{account_id}/paypal-checkout';
                service.getPaymentDetails.__http_method = 'GET';
                service.getPaymentDetails.__http_url = '/api/payments/v2/accounts/{account_id}/paypal-checkout/{order_id}/payment-details';
                service.updateCheckout.__http_method = 'PUT';
                service.updateCheckout.__http_url = '/api/payments/v2/accounts/{account_id}/paypal-checkout/{order_id}';
                return service;
            };
        },
        PayPalProviderEventsService: function () {
            return function (headers) {
                var service = {
                    handlePayPalEvent: function (rawHttpRequest) { return __awaiter(void 0, void 0, void 0, function () {
                        var requestTransformations, serializedPayload, response, responseTransformations, deSerializedResponse;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    requestTransformations = [{ typeName: 'bytes', pathInPayload: ['body'] }];
                                    serializedPayload = json_proto_serializer_1.batchToJson(rawHttpRequest, requestTransformations);
                                    return [4 /*yield*/, httpClient.invoke('POST', '/provider-events/paypal/{master_account_id}/{is_sandbox}', serializedPayload, headers)];
                                case 1:
                                    response = _a.sent();
                                    responseTransformations = [{ typeName: 'bytes', pathInPayload: ['body'] }];
                                    deSerializedResponse = json_proto_serializer_1.batchFromJson(response, responseTransformations);
                                    return [2 /*return*/, deSerializedResponse];
                            }
                        });
                    }); },
                };
                service.handlePayPalEvent.__http_method = 'POST';
                service.handlePayPalEvent.__http_url = '/provider-events/paypal/{master_account_id}/{is_sandbox}';
                return service;
            };
        },
        PlatformTransactionInfoService: function () {
            return function (headers) {
                var service = {
                    get: function (getTransactionInfoRequest) {
                        return httpClient.invoke('PUT', '/api/plugin/internal/v1/transactions/{transactionId}/info', getTransactionInfoRequest, headers);
                    },
                };
                service.get.__http_method = 'PUT';
                service.get.__http_url = '/api/plugin/internal/v1/transactions/{transactionId}/info';
                return service;
            };
        },
        PlatformTransactionService: function () {
            return function (headers) {
                var service = {
                    update: function (updateTransactionRequest) { return __awaiter(void 0, void 0, void 0, function () {
                        var requestTransformations, serializedPayload, response;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    requestTransformations = [{ typeName: 'google.protobuf.UInt64Value', pathInPayload: ['amount'] }];
                                    serializedPayload = json_proto_serializer_1.batchToJson(updateTransactionRequest, requestTransformations);
                                    return [4 /*yield*/, httpClient.invoke('PUT', '/api/plugin/v1/transactions/{transactionId}', serializedPayload, headers)];
                                case 1:
                                    response = _a.sent();
                                    return [2 /*return*/, response];
                            }
                        });
                    }); },
                };
                service.update.__http_method = 'PUT';
                service.update.__http_url = '/api/plugin/v1/transactions/{transactionId}';
                return service;
            };
        },
        PosTransactionService: function () {
            return function (headers) {
                var service = {
                    create: function (createPosTransactionRequest) {
                        return httpClient.invoke('POST', '/api/payments/v2/charges/{charge_id}/pos', createPosTransactionRequest, headers);
                    },
                };
                service.create.__http_method = 'POST';
                service.create.__http_url = '/api/payments/v2/charges/{charge_id}/pos';
                return service;
            };
        },
        ProviderAccountsService: function () {
            return function (headers) {
                var service = {
                    claim: function (claimRequest) { return httpClient.invoke('POST', '/api/merchant/v2/provider-accounts/{provider_id}/claim', claimRequest, headers); },
                    connect: function (connectRequest) {
                        return httpClient.invoke('POST', '/api/merchant/v2/provider-accounts/{provider_id}/connect', connectRequest, headers);
                    },
                };
                service.claim.__http_method = 'POST';
                service.claim.__http_url = '/api/merchant/v2/provider-accounts/{provider_id}/claim';
                service.connect.__http_method = 'POST';
                service.connect.__http_url = '/api/merchant/v2/provider-accounts/{provider_id}/connect';
                return service;
            };
        },
        ProviderPlatformEventsService: function () {
            return function (headers) {
                var service = {
                    submitEvent: function (submitEventRequest) { return __awaiter(void 0, void 0, void 0, function () {
                        var requestTransformations, serializedPayload, response;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    requestTransformations = [
                                        { typeName: 'int64', pathInPayload: ['event', 'refund', 'amount'] },
                                        { typeName: 'int64', pathInPayload: ['event', 'capture', 'amount'] },
                                        { typeName: 'int64', pathInPayload: ['event', 'void', 'amount'] },
                                    ];
                                    serializedPayload = json_proto_serializer_1.batchToJson(submitEventRequest, requestTransformations);
                                    return [4 /*yield*/, httpClient.invoke('POST', '/payments/v1/provider-platform-events', serializedPayload, headers)];
                                case 1:
                                    response = _a.sent();
                                    return [2 /*return*/, response];
                            }
                        });
                    }); },
                };
                service.submitEvent.__http_method = 'POST';
                service.submitEvent.__http_url = '/payments/v1/provider-platform-events';
                return service;
            };
        },
        RecurringPaymentService: function () {
            return function (headers) {
                var service = {
                    cancelRecurringPayment: function (cancelRecurringPaymentRequest) {
                        return httpClient.invoke('PUT', '/api/merchant/v2/orders/{order_id}/recurring-payment/cancellation', cancelRecurringPaymentRequest, headers);
                    },
                };
                service.cancelRecurringPayment.__http_method = 'PUT';
                service.cancelRecurringPayment.__http_url = '/api/merchant/v2/orders/{order_id}/recurring-payment/cancellation';
                return service;
            };
        },
        RefundService: function () {
            return function (headers) {
                var service = {
                    getRefunds: function (getRefundsRequest) { return __awaiter(void 0, void 0, void 0, function () {
                        var response, responseTransformations, deSerializedResponse;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, httpClient.invoke('GET', '/api/merchant/v2/transactions/{transaction_id}/refunds', getRefundsRequest, headers)];
                                case 1:
                                    response = _a.sent();
                                    responseTransformations = [{ typeName: 'google.protobuf.Timestamp', pathInPayload: ['refunds', 'createdAt'] }];
                                    deSerializedResponse = json_proto_serializer_1.batchFromJson(response, responseTransformations);
                                    return [2 /*return*/, deSerializedResponse];
                            }
                        });
                    }); },
                    refund: function (refundRequest) { return __awaiter(void 0, void 0, void 0, function () {
                        var response, responseTransformations, deSerializedResponse;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, httpClient.invoke('POST', '/api/merchant/v2/transactions/{transaction_id}/refund', refundRequest, headers)];
                                case 1:
                                    response = _a.sent();
                                    responseTransformations = [{ typeName: 'google.protobuf.Timestamp', pathInPayload: ['refund', 'createdAt'] }];
                                    deSerializedResponse = json_proto_serializer_1.batchFromJson(response, responseTransformations);
                                    return [2 /*return*/, deSerializedResponse];
                            }
                        });
                    }); },
                };
                service.getRefunds.__http_method = 'GET';
                service.getRefunds.__http_url = '/api/merchant/v2/transactions/{transaction_id}/refunds';
                service.refund.__http_method = 'POST';
                service.refund.__http_url = '/api/merchant/v2/transactions/{transaction_id}/refund';
                return service;
            };
        },
        TransactionService: function () {
            return function (headers) {
                var service = {
                    approve: function (approveTransactionRequest) {
                        return httpClient.invoke('POST', '/api/merchant/v2/transactions/{transaction_id}/approve', approveTransactionRequest, headers);
                    },
                    cancel: function (cancelTransactionRequest) {
                        return httpClient.invoke('POST', '/api/merchant/v2/transactions/{transaction_id}/cancel', cancelTransactionRequest, headers);
                    },
                    get: function (getTransactionRequest) { return __awaiter(void 0, void 0, void 0, function () {
                        var response, responseTransformations, deSerializedResponse;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, httpClient.invoke('GET', '/api/merchant/v2/transactions/{transaction_id}', getTransactionRequest, headers)];
                                case 1:
                                    response = _a.sent();
                                    responseTransformations = [
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['transaction', 'createdAt'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['transaction', 'refunds', 'createdAt'] },
                                    ];
                                    deSerializedResponse = json_proto_serializer_1.batchFromJson(response, responseTransformations);
                                    return [2 /*return*/, deSerializedResponse];
                            }
                        });
                    }); },
                    getFilters: function (getTransactionFiltersRequest) {
                        return httpClient.invoke('GET', '/api/merchant/v2/transactions/filters', getTransactionFiltersRequest, headers);
                    },
                    getPermissions: function (any) { return httpClient.invoke('GET', '/api/merchant/v2/transactions/permissions', any, headers); },
                    getTotals: function (getTransactionTotalsRequest) { return __awaiter(void 0, void 0, void 0, function () {
                        var requestTransformations, serializedPayload, response;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    requestTransformations = [
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['from'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['to'] },
                                    ];
                                    serializedPayload = json_proto_serializer_1.batchToJson(getTransactionTotalsRequest, requestTransformations);
                                    return [4 /*yield*/, httpClient.invoke('GET', '/api/merchant/v2/transactions/totals', serializedPayload, headers)];
                                case 1:
                                    response = _a.sent();
                                    return [2 /*return*/, response];
                            }
                        });
                    }); },
                    hasTransactions: function (hasTransactionsRequest) {
                        return httpClient.invoke('GET', '/api/merchant/v2/transactions/exist', hasTransactionsRequest, headers);
                    },
                    list: function (listTransactionsRequest) { return __awaiter(void 0, void 0, void 0, function () {
                        var requestTransformations, serializedPayload, response, responseTransformations, deSerializedResponse;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    requestTransformations = [
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['from'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['to'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['fromUpdated'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['toUpdated'] },
                                    ];
                                    serializedPayload = json_proto_serializer_1.batchToJson(listTransactionsRequest, requestTransformations);
                                    return [4 /*yield*/, httpClient.invoke('GET', '/api/merchant/v2/transactions', serializedPayload, headers)];
                                case 1:
                                    response = _a.sent();
                                    responseTransformations = [
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['transactions', 'createdAt'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['transactions', 'refunds', 'createdAt'] },
                                    ];
                                    deSerializedResponse = json_proto_serializer_1.batchFromJson(response, responseTransformations);
                                    return [2 /*return*/, deSerializedResponse];
                            }
                        });
                    }); },
                };
                service.approve.__http_method = 'POST';
                service.approve.__http_url = '/api/merchant/v2/transactions/{transaction_id}/approve';
                service.cancel.__http_method = 'POST';
                service.cancel.__http_url = '/api/merchant/v2/transactions/{transaction_id}/cancel';
                service.get.__http_method = 'GET';
                service.get.__http_url = '/api/merchant/v2/transactions/{transaction_id}';
                service.getFilters.__http_method = 'GET';
                service.getFilters.__http_url = '/api/merchant/v2/transactions/filters';
                service.getPermissions.__http_method = 'GET';
                service.getPermissions.__http_url = '/api/merchant/v2/transactions/permissions';
                service.getTotals.__http_method = 'GET';
                service.getTotals.__http_url = '/api/merchant/v2/transactions/totals';
                service.hasTransactions.__http_method = 'GET';
                service.hasTransactions.__http_url = '/api/merchant/v2/transactions/exist';
                service.list.__http_method = 'GET';
                service.list.__http_url = '/api/merchant/v2/transactions';
                return service;
            };
        },
    };
};
exports.PaymentServicesWeb = PaymentServicesWeb;
exports.PaymentServicesWeb.__transport = 'http';
__exportStar(require("./types"), exports);
//# sourceMappingURL=http.js.map